import "./SectionTitle.css";

const SectionTitle = ({ title, subtitle, align = "center" }) => {
	return (
		<div className={`section-title ${align}`}>
			<h2>{title}</h2>
			{subtitle && <p className="subtitle">{subtitle}</p>}
		</div>
	);
};

export default SectionTitle;
